import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { API_URL } from '@/config';


export function AuthCallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const handleCallback = async () => {
      const accessToken = searchParams.get('access_token');
      const refreshToken = searchParams.get('refresh_token');
      const tokenType = searchParams.get('token_type') || 'bearer';
      const expiresIn = parseInt(searchParams.get('expires_in') || '3600');

      if (accessToken && refreshToken) {
        try {
          const tokens = {
            access_token: accessToken,
            refresh_token: refreshToken,
            token_type: tokenType,
            expires_in: expiresIn,
          };

          // Set tokens first so we can make authenticated requests
          useAuthStore.setState({
            token: accessToken,
            refreshToken: refreshToken,
            tokens,
            isAuthenticated: true,
          });

          // Fetch full user profile from /me endpoint
          const meResponse = await fetch(`${API_URL}/api/v1/auth/me`, {
            headers: { 'Authorization': `Bearer ${accessToken}` },
          });

          if (meResponse.ok) {
            const userData = await meResponse.json();
            useAuthStore.setState({ user: userData });
          } else {
            // Fallback: decode JWT for basic user info
            const tokenParts = accessToken.split('.');
            const payload = JSON.parse(atob(tokenParts[1]));
            useAuthStore.setState({
              user: {
                id: payload.sub,
                email: payload.email || '',
                username: payload.username || '',
                role: payload.role || 'viewer',
                organization_id: payload.org || '',
                is_active: true,
                created_at: new Date().toISOString(),
                updated_at: new Date().toISOString(),
              }
            });
          }

          navigate('/dashboard');
        } catch (error) {
          console.error('Failed to process authentication:', error);
          navigate('/login?error=auth_failed');
        }
      } else {
        navigate('/login?error=missing_tokens');
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>
        <p className="mt-4 text-gray-400">Completing authentication...</p>
      </div>
    </div>
  );
}
